export default {
  SET_TREE_DATA: 'setTreeData',
}
